export default {
    // baseUrl: 'https://ysxy.yishaxiyi.com/factoryapi',// 开发阶段测试地址
    baseUrl: 'https://ceshi.yishaxiyi.com/factoryapi',// 上线正式地址
    prefix: '',//缓存前缀
    a:'https://ceshi.yishaxiyi.com/factoryUpadate/index.html'
}